import { render, staticRenderFns } from "./HandoverBtns.vue?vue&type=template&id=513b7808"
import script from "./HandoverBtns.vue?vue&type=script&lang=ts"
export * from "./HandoverBtns.vue?vue&type=script&lang=ts"
import style0 from "./HandoverBtns.vue?vue&type=style&index=0&id=513b7808&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports